import styled from 'styled-components';

import { Image } from '@sharedComponents/Images';
import { Bold, StyledPointerEventsWrapper } from '@styles/generalStyles';

export const StyledFundRaisingTitle = styled(StyledPointerEventsWrapper)`
  display: flex;
  align-items: center;
`;

export const StyledTitle = styled(Bold)`
  display: flex;
  align-items: center;
  margin-right: 0.3125rem;
`;

export const StyledImage = styled(Image)`
  width: 1.875rem;
  height: 100%;
  padding-right: 0.5rem;
`;
